// import { makeBanner } from '../../components/banner/banner'
import { waitForElement } from '../../js/utils'

// export const leaderboard = () => {
//   waitForElement('.en__p2p__leaderboard__page').then((leaderboardPage) => {
//     console.log('leaderboard page found')
//     document.documentElement.classList.add('p2p-leaderboard')
//   })
// }

class Leaderboard {
  constructor() {
    this.leaderboard = null

    waitForElement('.en__p2p__leaderboard--list').then((leaderboard) => {
      console.log('leaderboard page found')
      this.leaderboard = leaderboard
      this.render()
    })
  }

  render() {
    this.wrapLeaderboardElements()
  }

  wrapLeaderboardElements() {
    const leaderboard = this.leaderboard
    const previousText = leaderboard.previousElementSibling

    if (previousText) {
      const wrapper = document.createElement('div')

      wrapper.appendChild(previousText.cloneNode(true))
      wrapper.appendChild(leaderboard)
      wrapper.classList.add('mt-5')
      previousText.parentNode.insertBefore(wrapper, previousText.nextSibling)
      previousText.remove()
    }
  }
}

export default Leaderboard
